module.exports = __webpack_public_path__ + "img/symbol_1.b6b327b0.png";